export function getQueryString(name) {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	var r = window.location.search.substr(1).match(reg);
	if (r != null) {
		return unescape(r[2]);
	}
	return null;
}
export function dateFormat(fmt, date) {
	if (typeof date === 'string' || typeof date === 'number') {
		date = new Date(date);
	}
	let ret;
	const opt = {
		'Y+': date.getFullYear().toString(),        // 年
		'm+': (date.getMonth() + 1).toString(),     // 月
		'd+': date.getDate().toString(),            // 日
		'H+': date.getHours().toString(),           // 时
		'M+': date.getMinutes().toString(),         // 分
		'S+': date.getSeconds().toString()          // 秒
	};
	for (let k in opt) {
		ret = new RegExp('(' + k + ')').exec(fmt);
		if (ret) {
		fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')));
		}
	}
	return fmt;
}